import React, { useState } from "react";
import { Button, Modal, Typography, Textarea } from "@plum-xoxo/admin-dsm";
import reportService from "../../../../services/reportService";
import profileService from "../../../../services/profileService";
import { NotificationManager } from "react-notifications";
import bulkProcessService from "../../../../services/bulkProcessService";
import CancelReason from "./cancelReason";

const UpdateReportPopup = ({
  updateReportPopup,
  setUpdateReportPopup,
  viewDetailModalData,
  columns,
  setColumns,
  title,
  selectedCategory,
}) => {
  const [loading, setLoading] = useState(false);
  const [cancelReason, setCancelReasonMessage] = useState("");

  const resend = {
    title: "Resend reward confirmation",
    subtitle:
      "You are about to resend the reward confirmation to 1 recipient(s). Do you want to proceed?",
  };
  const cancel = {
    title: "Cancel Reward",
    subtitle:
      "You have selected 1 reward entries for cancellation. Do you want to proceed with the cancellation?    ",
  };
  const modalData = {
    title: updateReportPopup === "resend" ? resend.title : cancel.title,
    subtitle:
      updateReportPopup === "resend" ? resend.subtitle : cancel.subtitle,
  };

  const resendMail = async () => {
    let response;
    setLoading(true);
    if (title === "xoxo reward points") {
      response = await reportService.xoxoPointResend(
        parseInt(atob(viewDetailModalData.voucher_id))
      );

      response = JSON.parse(response);
    } else if (title === "xoxo reward code") {
      response = await reportService.plumResendVoucher({
        voucher_id: parseInt(atob(viewDetailModalData.voucher_id)),
      });
    } else if (title === "xoxo reward link") {
      response = await reportService.resendSingleXoxoLink(
        viewDetailModalData.link_id
      );
      response = response?.data?.resendSingleXoxoLink;
    } else if (title === "xoxo rewards api") {
      let add_data = {
        order_id: viewDetailModalData.order_id,
        email: viewDetailModalData.receiver_email,
      };
      if (
        viewDetailModalData?.shipping_method !== "email" &&
        viewDetailModalData?.source === "plumProAPI"
      ) {
        //dialog box text
        response = await reportService.resendPlumProApiOrder(add_data);
      } else {
        response = await reportService.resendPlumPlatformOrder(add_data);
        response = response?.data?.resendVoucherAdmin;
      }
    }
    if (
      response?.success ||
      response?.error === false ||
      response?.Error === false
    ) {
      setUpdateReportPopup("");
      setLoading(false);
      NotificationManager.success("Reward detail resent successfully");
    } else {
      setUpdateReportPopup("");
      setLoading(false);
      NotificationManager.error(response.message);
    }
  };
  const cancelMail = async () => {
    let response;
    let msg;
    setLoading(true);
    if (title === "xoxo reward points") {
      if (selectedCategory === 0) {
        response = await reportService.xoxoPointCancel(
          parseInt(atob(viewDetailModalData.voucher_id)),
          cancelReason
        );
        response = JSON.parse(response);
      } else {
        const params = {
          batch_id: viewDetailModalData.batch_id || "",
          id: viewDetailModalData.id || "",
          reward_type: 1,
        };
        response = await bulkProcessService.cancelScheduledData(params);
        response = response.bulkCancelScheduleData;
      }
      msg = response?.message ? response?.message[0] : "";
    } else if (title === "xoxo reward code") {
      if (selectedCategory === 0) {
        response = await reportService.xoxoVoucherCodeCancel(
          parseInt(atob(viewDetailModalData.voucher_id)),
          cancelReason
        );
        response = JSON.parse(response);
        msg = response.message ? response.message[0] : "";
      } else {
        let params = {
          batch_id: viewDetailModalData["batch_id"] || "",
          id: viewDetailModalData["id"] || "",
          reward_type: 2,
        };
        response = await bulkProcessService.cancelScheduledData(params);
        response = response.bulkCancelScheduleData;
        msg = response.message ? response.message[0] : "";
      }
    } else if (title === "xoxo reward link") {
      response = await reportService.cancelSingleXoxoLinkLink(
        viewDetailModalData.link_id,
        cancelReason
      );
      response = response?.data?.cancelSingleXoxoLink;
      msg = response?.message;
    }
    if (
      (response?.success && response.success !== "0") ||
      response?.error === false
    ) {
      setColumns(columns);
      setUpdateReportPopup("");
      setLoading(false);
      NotificationManager.success(
        msg || "Cancellation request completed successfully"
      );
    } else {
      setUpdateReportPopup("");
      setLoading(false);
      NotificationManager.error(response?.errors?.msg || msg);
    }
  };
  return (
    <div>
      <Modal
        isOpen={
          updateReportPopup === "resend" || updateReportPopup === "cancel"
        }
        onClose={() => {
          setUpdateReportPopup("");
        }}
        disableCloseButton={false}
        timeout={0}
      >
        <Typography.H3>{modalData.title}</Typography.H3>
        <Typography className="mt-16">{modalData.subtitle}</Typography>
        <div
          style={{
            textAlign: "right",
          }}
        >
          {updateReportPopup === "cancel" ? (
            <CancelReason
              cancelReason={cancelReason}
              setCancelReasonMessage={setCancelReasonMessage}
            />
          ) : null}
          <Button
            color="primary"
            variant="plain"
            mr="1"
            onClick={() => {
              setUpdateReportPopup("");
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="fill"
            loading={loading}
            disabled={loading}
            onClick={() => {
              if (updateReportPopup === "resend") {
                resendMail();
              } else if (updateReportPopup === "cancel") {
                cancelMail();
              }
            }}
          >
            Confirm
          </Button>
        </div>
      </Modal>
    </div>
  );
};

export default UpdateReportPopup;
